import request from '@/utils/request'

const api = {
    getUserCustomerList: '/customer/getUserCustomerList',
    getUserCustomerListByUser: "/customer/getUserCustomerListByUser",
    standardStar: "/customer/standardStar",
    customerDetails: "/customer/customerDetails",
    addUserCustomerLog: "/customer/addUserCustomerLog",
    exportAllCustomerDetails: "/customer/exportAllCustomerDetails",
    exportCustomerDetails: "/customer/exportCustomerDetails",
}

export function getUserCustomerList(data) {
    return request({
        url: api.getUserCustomerList,
        method: 'post',
        data
    })
}

export function getUserCustomerListByUser(data) {
    return request({
        url: api.getUserCustomerListByUser,
        method: 'post',
        data
    })
}

export function getStandardStar(data) {
    return request({
        url: api.standardStar,
        method: 'post',
        data
    })
}

export function getCustomerDetails(data) {
    return request({
        url: api.customerDetails,
        method: 'post',
        data
    })
}

export function addUserCustomerLog(data) {
    return request({
        url: api.addUserCustomerLog,
        method: 'post',
        data
    })
}

export function exportAllCustomerDetails() {
    return request({
        url: api.exportAllCustomerDetails,
        method: 'post'
    })
}

export function exportCustomerDetails(data) {
    return request({
        url: api.exportCustomerDetails,
        method: 'post',
        data
    })
}